import { render } from "./ChorusContent.vue?vue&type=template&id=8296d506&scoped=true"
import script from "./ChorusContent.vue?vue&type=script&lang=js"
export * from "./ChorusContent.vue?vue&type=script&lang=js"

import "./ChorusContent.vue?vue&type=style&index=0&id=8296d506&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8296d506"]])

export default __exports__